import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss'
import ElementUi from 'element-ui'
import * as filters from './filters'
// import echarts from 'echarts'
import store from '@/store'
import { mixin } from '@/mixin/index'
import locale from 'element-ui/lib/locale/lang/en'
import PayPal from 'vue-paypal-checkout'
Vue.component('paypal-checkout', PayPal)
// Vue.prototype.$echarts = echarts

Vue.use(ElementUi, { locale })
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.mixin({
  ...mixin
})

Vue.directive('removeAriaHidden', {
  bind(el) {
    const ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
